import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { site, nav } from "../../data/content";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative bg-brand-primary text-white"
      data-testid="site-footer"
    >
      <div className="max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 pt-20 lg:pt-28 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Link to="/" className="inline-flex items-center gap-2.5">
              <Logo className="h-10 w-10" />
              <span className="text-lg font-semibold tracking-tight">
                Metalotsen
              </span>
            </Link>
            <p className="mt-6 text-white/60 max-w-md leading-relaxed">
              Wir machen Unternehmen sichtbar. Webdesign, Social Media,
              KI-Marketing und Recruiting — persönlich betreut aus Leipzig.
            </p>

            <a
              href="#kontakt"
              className="mt-10 inline-flex items-center gap-2 text-brand-accent font-medium hover:text-white transition-colors"
              data-testid="footer-cta"
            >
              Kostenloses Erstgespräch <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow-muted text-white/50">Navigation</p>
            <ul className="mt-4 space-y-2 text-white/80">
              {nav.map((n) => (
                <li key={n.id}>
                  <a href={n.href} className="hover:text-white transition-colors">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="eyebrow-muted text-white/50">Rechtliches</p>
            <ul className="mt-4 space-y-2 text-white/80">
              <li>
                <Link to="/impressum" className="hover:text-white transition-colors" data-testid="footer-imprint">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-privacy">
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="eyebrow-muted text-white/50">Kontakt</p>
            <address className="not-italic mt-4 text-white/80 leading-relaxed">
              {site.address.street}
              <br />
              {site.address.zip} {site.address.city}
              <br />
              {site.address.country}
              <br />
              <a href={`mailto:${site.email}`} className="mt-2 inline-block hover:text-white transition-colors">
                {site.email}
              </a>
            </address>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-white/50">
          <p>© {year} Metalotsen · Björn Richter · Alle Rechte vorbehalten.</p>
          <p className="tracking-widest uppercase text-[11px]">
            Made with craft in Leipzig
          </p>
        </div>
      </div>
    </footer>
  );
}
